/* eslint-disable */
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * @private
 */
export class Dictionary {
    constructor() {
        this.keysInternal = [];
        this.valuesInternal = [];
    }
    /**
     * @private
     */
    get length() {
        return this.keysInternal.length;
    }
    /**
     * @private
     */
    get keys() {
        return this.keysInternal;
    }
    /**
     * @private
     */
    get values() {
        return this.valuesInternal;
    }
    /**
     * @private
     */
    add(key, value) {
        if (isNullOrUndefined(key)) {
            throw new ReferenceError('Provided key or value is not valid.');
        }
        let index = this.keysInternal.indexOf(key);
        // if (index < 0 || index > this.keysInternal.length - 1) {
        if (index < 0) {
            this.keysInternal.push(key);
            this.valuesInternal.push(value);
        }
        return 1;
        // else {
        //     throw new RangeError('An item with the same key has already been added.');
        // }
    }
    /**
     * @private
     */
    get(key) {
        if (isNullOrUndefined(key)) {
            throw new ReferenceError('Provided key is not valid.');
        }
        let index = this.keysInternal.indexOf(key);
        if (index < 0 || index > this.keysInternal.length - 1) {
            return undefined;
            //throw new RangeError('No item with the specified key has been added.');
        }
        else {
            return this.valuesInternal[index];
        }
    }
    /**
     * @private
     */
    set(key, value) {
        if (isNullOrUndefined(key)) {
            throw new ReferenceError('Provided key is not valid.');
        }
        let index = this.keysInternal.indexOf(key);
        if (index < 0 || index > this.keysInternal.length - 1) {
            throw new RangeError('No item with the specified key has been added.');
        }
        else {
            this.valuesInternal[index] = value;
        }
    }
    /**
     * @private
     */
    remove(key) {
        if (isNullOrUndefined(key)) {
            throw new ReferenceError('Provided key is not valid.');
        }
        let index = this.keysInternal.indexOf(key);
        if (index < 0 || index > this.keysInternal.length - 1) {
            throw new RangeError('No item with the specified key has been added.');
        }
        else {
            this.keysInternal.splice(index, 1);
            this.valuesInternal.splice(index, 1);
            return true;
        }
    }
    /**
     * @private
     */
    containsKey(key) {
        if (isNullOrUndefined(key)) {
            throw new ReferenceError('Provided key is not valid.');
        }
        let index = this.keysInternal.indexOf(key);
        if (index < 0 || index > this.keysInternal.length - 1) {
            return false;
        }
        return true;
    }
    /**
     * @private
     */
    clear() {
        this.keysInternal = [];
        this.valuesInternal = [];
    }
    /**
     * @private
     */
    destroy() {
        this.clear();
        this.keysInternal = undefined;
        this.valuesInternal = undefined;
    }
}
